import {
  IToasterConfig as ToastConfig,
  OnActionCallback,
} from 'angular2-toaster';

export interface IToasterData {
  toastId?: string;
  onPrimaryAction?: Function;
  onDismiss?: Function;
  label: string;
  containsHtml?: boolean;
  type?: ToasterTypeEnum;
}

export interface IToasterConfig extends ToastConfig {
  type: string;
  component: any;
  data?: IToasterData;
  onShow?: OnActionCallback;
  onPrimaryAction?: OnActionCallback;
  onDismiss?: OnActionCallback;
  toastContainerId?: number;
}

export const GLOBAL_CONTAINER_ID = 1;

export const TOASTER_TIMEOUT = 5000;

export enum ToasterTypeEnum {
  warning = 'warning',
}
